import { axiosInstance } from "./axiosInstance";

export interface IFundraisers
{
  fundraiserId: number,
  title: string,
  recipientName: string,
  url: string,
  userId: number
}

export async function getFundraisers()
{
  return axiosInstance.post("/fundraisers/fundraisers")
    .then(resJson => resJson.data as IFundraisers[])
    .catch(error => console.log("Error getting fundraisers ", error));
}

export async function postNewFundraiser(
  title: string,
  recipientName: string,
  url: string)
{
  return axiosInstance.post("/fundraisers/new", {
    "Title": title,
    "RecipientName": recipientName,
    "Url": url })
    .then(resJson => resJson.data as { fundraiserId: number })
    .catch(error => console.log("Error submitting new fundraiser:", error));
}

export async function deleteFundraiser(FundraiserIdToRemove: number)
{
  return axiosInstance.post("/fundraisers/delete", {
    "FundraiserIdToRemove": FundraiserIdToRemove })
    .catch(error => console.log("Error deleting fundraiser:", error));
}
